import { render, staticRenderFns } from "./product_market.vue?vue&type=template&id=d15a5122&scoped=true&"
import script from "./product_market.vue?vue&type=script&lang=js&"
export * from "./product_market.vue?vue&type=script&lang=js&"
import style0 from "./product_market.vue?vue&type=style&index=0&id=d15a5122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a5122",
  null
  
)

export default component.exports